import url from './url';



export default url(() => '/push-icons');
